import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** If the buttons are stacked vertically  */
  isVertical?: boolean;
  /** The list of Buttons or InputButtons */
  children?: React.ReactNode;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
}
const ButtonGroupStyled = /*#__PURE__*/styled('div')({
  name: "ButtonGroupStyled",
  class: "b1aod48f",
  propsAsIs: false
});
export const ButtonGroup = ({
  isVertical = false,
  children,
  className,
  dataId
}: Props) => {
  return <ButtonGroupStyled data-id={dataId} className={cx(isVertical && 'isVertical', !isVertical && 'isHorizontal', className)}>
      {children}
    </ButtonGroupStyled>;
};

require("./ButtonGroup.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ButtonGroup.tsx");